import { render, staticRenderFns } from "./CoTwoSetCreationForm.vue?vue&type=template&id=2675661a&scoped=true&"
import script from "./CoTwoSetCreationForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoSetCreationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2675661a",
  null
  
)

export default component.exports